export default "__VITE_ASSET__DxayI4qr__"